import { Component, Input, Output, EventEmitter } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ClientConfigurationApproval } from 'app/core/models/client-configuration-approval.model';

@Component({
  selector: 'app-client-configuration-approval-button',
  templateUrl: './client-configuration-approval-button.component.html',
  imports: [DatePipe],
})
export class ClientConfigurationApprovalButtonComponent {
  @Input() approval: ClientConfigurationApproval | null;
  @Output() approve = new EventEmitter<void>();

  get isApproved(): boolean {
    return !!this.approval?.approvedAt;
  }

  onApproveClick() {
    this.approve.emit();
  }
}
